import {
  ComputedRoute,
  FacilitiesCard,
  RoadTypeBar,
  RoadTypeLegend,
  Route,
  TRoadTypeLegendEntry,
} from '@geovelo-frontends/commons';
import { Box, Card, CardContent, Skeleton, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const surfaces: Array<TRoadTypeLegendEntry> = [
  {
    key: 'routes',
    color: '#a066eb',
    labelKey: 'commons.facilities_legend.roads',
    descriptionKey: '',
  },
  {
    key: 'paths',
    color: '#ffd12f',
    labelKey: 'commons.facilities_legend.paths',
    descriptionKey: '',
  },
  {
    key: 'dirtRoads',
    color: '#ef9757',
    labelKey: 'commons.facilities_legend.dirt_roads',
    descriptionKey: '',
  },
  {
    key: 'others',
    color: '#666666',
    labelKey: 'commons.facilities_legend.other',
    descriptionKey: '',
  },
];

function RoadTypes({
  disableTitle,
  size,
  layout,
  route,
}: {
  disableTitle?: boolean;
  layout?: 'row';
  route: ComputedRoute | Route | null | undefined;
  size?: 'small';
}): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {!disableTitle && (
        <Box alignItems="center" display="flex" gap={2}>
          <Typography
            component="h2"
            fontWeight={size === 'small' ? 600 : 700}
            variant={size === 'small' ? 'body1' : 'h6'}
          >
            {t('geovelo.rides.detail.road_types')}
          </Typography>
        </Box>
      )}
      <Box display="flex" flexDirection={layout || 'column'} gap={2}>
        <FacilitiesCard layout={layout} route={route} size={size} />
        {(!route || 'cyclingQualityAsphalt' in route.distances) && (
          <Card
            sx={{ borderRadius: 4, width: layout === 'row' ? 'calc((100% - 16px) / 2)' : '100%' }}
            variant="outlined"
          >
            <CardContent
              sx={{ '&&': { display: 'flex', flexDirection: 'column', gap: 2, padding: 2 } }}
            >
              <Typography fontSize={size === 'small' ? '1rem' : '1.1rem'} fontWeight={600}>
                {route ? (
                  t('commons.routing.distances.cycling_quality', {
                    value: route.asphaltRoadsPercentage,
                  })
                ) : (
                  <Skeleton variant="text" width={150} />
                )}
              </Typography>
              <RoadTypeBar
                entries={surfaces}
                values={
                  route
                    ? [
                        route.asphaltRoadsPercentage,
                        route.pathsPercentage,
                        route.damagedTracksPercentage,
                        route.otherRoadsQualityPercentage,
                      ]
                    : undefined
                }
              />
              <RoadTypeLegend entries={surfaces} />
            </CardContent>
          </Card>
        )}
      </Box>
    </Box>
  );
}

export default RoadTypes;
